function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created with Lunacy");

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "rocket"
}), /*#__PURE__*/React.createElement("clipPath", {
  id: "rocket_mask"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#rocket"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "rocket-(1)-1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0L36 0L36 36L0 36L0 0Z",
  id: "rocket-(1)-1-(Background/Mask)",
  fill: "none",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#rocket_mask)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M5.66495 0.18091L3.51535 1.55637C0.220837 3.66433 -0.946637 7.92748 0.824001 11.4222L3.407 16.5203C3.71755 17.1333 4.49777 17.3362 5.06765 16.9497C7.71236 15.1567 9.09131 12.0032 8.60978 8.8424L7.4106 0.971414C7.28625 0.154911 6.3609 -0.264267 5.66495 0.18091Z",
  transform: "translate(4.3164062 17.801758)",
  id: "Vector",
  fill: "#A2D0F9",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M3.03962 0.180922C2.34375 -0.264255 1.41833 0.154852 1.29398 0.971426L0.0947957 8.84241C-0.38645 12.0011 0.990508 15.1556 3.63693 16.9497C4.20403 17.3342 4.98524 17.1368 5.29758 16.5203L7.88058 11.4222C9.64821 7.93327 8.48924 3.66784 5.18916 1.55631L5.18916 1.55631L3.03962 0.180922Z",
  transform: "translate(22.978516 17.801758)",
  id: "Vector",
  fill: "#A2D0F9",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 0.607469C0.0671373 1.62296 0.337686 2.62294 0.806718 3.54872L3.38972 8.64687C3.70055 9.26039 4.48056 9.46266 5.05036 9.07626C7.69507 7.28327 9.07403 4.12975 8.5925 0.968939L8.45529 0.0685865C7.2134 -0.0649738 6.10356 -0.0168353 5.20228 0.332064L5.20228 0.332064C3.59042 0.955941 1.7645 0.937227 0 0.607469Z",
  transform: "translate(4.3339844 25.675293)",
  id: "Vector",
  fill: "#8BC4FF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M0 1.31503C0.102349 3.94003 1.44252 6.36704 3.62941 7.84963C4.19651 8.23409 4.97773 8.03668 5.29006 7.42023C7.9769 2.11711 8.3723 1.61922 8.61371 0L8.61371 0C6.83657 2.28845 3.57534 2.11997 0 1.31503Z",
  transform: "translate(22.986328 26.901978)",
  id: "Vector",
  fill: "#8BC4FF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1.14275 0C0.492166 0 -0.027577 0.543098 0.00113492 1.19304C0.119554 3.88196 0.590158 6.47568 1.3998 8.90212C1.55543 9.36858 1.99204 9.6832 2.48379 9.6832L14.3856 9.6832C14.8773 9.6832 15.3139 9.36858 15.4696 8.90212C16.2792 6.47568 16.7497 3.88196 16.8682 1.19304C16.8969 0.543098 16.3771 0 15.7265 0L15.7265 0L1.14275 0Z",
  transform: "translate(9.56543 19.017822)",
  id: "Vector",
  fill: "#80B9ED",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.8682 1.19305C16.8969 0.543099 16.3771 0 15.7266 0L1.14275 0C0.492166 0 -0.027577 0.543099 0.00113492 1.19305C0.0661295 2.669 0.237901 4.11595 0.512949 5.52255C2.98667 6.47011 5.86158 6.81237 8.04304 4.8416C9.97673 3.09467 13.3778 2.7682 16.7336 2.99583C16.796 2.40016 16.8415 1.79914 16.8682 1.19305Z",
  transform: "translate(9.56543 19.017822)",
  id: "Vector",
  fill: "#8BC4FF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("g", {
  id: "Group",
  transform: "translate(4.3164062 0.00012207031)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M22.1407 18.2635C21.9715 9.93794 18.5175 3.53354 14.3956 0.249033C13.9789 -0.0830109 13.388 -0.0830109 12.9713 0.249033C8.84797 3.53476 5.39526 9.94687 5.2262 18.2635L3.51535 19.3582C0.220837 21.4661 -0.946637 25.7293 0.824001 29.224L3.407 34.3221C3.71783 34.9356 4.49784 35.1379 5.06765 34.7515C7.08648 33.3828 8.42258 31.1753 8.66442 28.7009L12.5407 28.7009L12.5407 34.8571C12.5407 35.4882 13.0523 35.9999 13.6834 35.9999C14.3145 35.9999 14.8262 35.4882 14.8262 34.8571L14.8262 28.7009L18.7024 28.7009C18.9354 31.085 20.2046 33.3315 22.2992 34.7515C22.868 35.1371 23.6483 34.9371 23.9599 34.3221L26.5429 29.224C28.3105 25.7351 27.1515 21.4697 23.8514 19.3582L22.1407 18.2635ZM19.8606 19.0178L14.8262 19.0178C14.8262 17.403 12.5407 17.401 12.5407 19.0178L7.5063 19.0178C7.46952 11.6817 10.2399 5.80657 13.6834 2.64619C17.1313 5.81064 19.8966 11.6869 19.8606 19.0178ZM2.86276 28.1911C1.61901 25.7362 2.42915 22.7665 4.74717 21.2833L5.2902 20.9359C5.43033 23.005 5.78202 25.014 6.34254 26.9376C6.63937 28.8854 5.99686 30.7087 4.79181 31.9985L2.86276 28.1911ZM7.60951 21.3033L12.5407 21.3033L12.5407 26.4154L8.5705 26.4154C8.08397 24.776 7.76264 23.0657 7.60951 21.3033ZM19.7574 21.3033C19.6042 23.0658 19.2829 24.776 18.7964 26.4155L14.8262 26.4155L14.8262 21.3033L19.7574 21.3033ZM22.575 31.9985C21.3361 30.6725 20.7373 28.8209 21.0165 26.9884C21.0502 26.7678 21.839 24.4454 22.0767 20.9359L22.6197 21.2833C24.9377 22.7665 25.7479 25.7362 24.5041 28.1911L22.575 31.9985Z",
  id: "Vector",
  fill: "#3A4AAF",
  fillRule: "evenodd",
  stroke: "none"
}), /*#__PURE__*/React.createElement("path", {
  d: "M2.56043 5.12086C1.14634 5.12086 0 3.97452 0 2.56043C0 1.14634 1.14634 0 2.56043 0C3.97451 0 5.12086 1.14634 5.12086 2.56043C5.12086 3.97452 3.97451 5.12086 2.56043 5.12086Z",
  transform: "translate(11.123047 9.707642)",
  id: "Vector",
  fill: "#FFD300",
  fillRule: "evenodd",
  stroke: "none"
}))));

var SvgRocket = function SvgRocket(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "36px",
    viewBox: "0 0 36 36",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRocket, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/rocket.88019b3e.svg";
export { ForwardRef as ReactComponent };